module.exports = __webpack_public_path__ + "assets/img/btn-view-info-hover-f8a9131c.png";